"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var queryable_1 = require("./queryable");
var items_1 = require("./items");
var util_1 = require("../../utils/util");
var Files = (function (_super) {
    __extends(Files, _super);
    function Files(baseUrl, path) {
        if (path === void 0) { path = "files"; }
        _super.call(this, baseUrl, path);
    }
    Files.prototype.getByName = function (name) {
        var f = new File(this);
        f.concat("('" + name + "')");
        return f;
    };
    Files.prototype.add = function (url, content, shouldOverWrite) {
        var _this = this;
        if (shouldOverWrite === void 0) { shouldOverWrite = true; }
        return new Files(this, "add(overwrite=" + shouldOverWrite + ",url='" + url + "')")
            .post({
            body: content,
        }).then(function (response) {
            return {
                data: response,
                file: _this.getByName(url),
            };
        });
    };
    Files.prototype.addChunked = function (url, content, progress, shouldOverWrite, chunkSize) {
        var _this = this;
        if (shouldOverWrite === void 0) { shouldOverWrite = true; }
        if (chunkSize === void 0) { chunkSize = 10485760; }
        var adder = new Files(this, "add(overwrite=" + shouldOverWrite + ",url='" + url + "')");
        return adder.post().then(function () { return _this.getByName(url); }).then(function (file) { return file.setContentChunked(content, progress, chunkSize); }).then(function (response) {
            return {
                data: response,
                file: _this.getByName(url),
            };
        });
    };
    Files.prototype.addTemplateFile = function (fileUrl, templateFileType) {
        var _this = this;
        return new Files(this, "addTemplateFile(urloffile='" + fileUrl + "',templatefiletype=" + templateFileType + ")")
            .post().then(function (response) {
            return {
                data: response,
                file: _this.getByName(fileUrl),
            };
        });
    };
    return Files;
}(queryable_1.QueryableCollection));
exports.Files = Files;
var File = (function (_super) {
    __extends(File, _super);
    function File(baseUrl, path) {
        _super.call(this, baseUrl, path);
    }
    Object.defineProperty(File.prototype, "listItemAllFields", {
        get: function () {
            return new items_1.Item(this, "listItemAllFields");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(File.prototype, "versions", {
        get: function () {
            return new Versions(this);
        },
        enumerable: true,
        configurable: true
    });
    File.prototype.approve = function (comment) {
        return new File(this, "approve(comment='" + comment + "')").post();
    };
    File.prototype.cancelUpload = function (uploadId) {
        return new File(this, "cancelUpload(uploadId=guid'" + uploadId + "')").post();
    };
    File.prototype.checkin = function (comment, checkinType) {
        if (comment === void 0) { comment = ""; }
        if (checkinType === void 0) { checkinType = CheckinType.Major; }
        return new File(this, "checkin(comment='" + comment + "',checkintype=" + checkinType + ")").post();
    };
    File.prototype.checkout = function () {
        return new File(this, "checkout").post();
    };
    File.prototype.copyTo = function (url, shouldOverWrite) {
        if (shouldOverWrite === void 0) { shouldOverWrite = true; }
        return new File(this, "copyTo(strnewurl='" + url + "',boverwrite=" + shouldOverWrite + ")").post();
    };
    File.prototype.delete = function (eTag) {
        if (eTag === void 0) { eTag = "*"; }
        return new File(this).post({
            headers: {
                "IF-Match": eTag,
                "X-HTTP-Method": "DELETE",
            },
        });
    };
    File.prototype.deny = function (comment) {
        if (comment === void 0) { comment = ""; }
        return new File(this, "deny(comment='" + comment + "')").post();
    };
    File.prototype.getLimitedWebPartManager = function (scope) {
        if (scope === void 0) { scope = WebPartsPersonalizationScope.User; }
        return new queryable_1.Queryable(this, "getLimitedWebPartManager(scope=" + scope + ")");
    };
    File.prototype.moveTo = function (url, moveOperations) {
        if (moveOperations === void 0) { moveOperations = MoveOperations.Overwrite; }
        return new File(this, "moveTo(newurl='" + url + "',flags=" + moveOperations + ")").post();
    };
    File.prototype.publish = function (comment) {
        if (comment === void 0) { comment = ""; }
        return new File(this, "publish(comment='" + comment + "')").post();
    };
    File.prototype.recycle = function () {
        return new File(this, "recycle").post();
    };
    File.prototype.undoCheckout = function () {
        return new File(this, "undoCheckout").post();
    };
    File.prototype.unpublish = function (comment) {
        if (comment === void 0) { comment = ""; }
        if (comment.length > 1023) {
            throw new Error("The maximum comment length is 1023 characters.");
        }
        return new File(this, "unpublish(comment='" + comment + "')").post();
    };
    File.prototype.getText = function () {
        return new File(this, "$value").get(new TextFileParser(), { headers: { "binaryStringResponseBody": "true" } });
    };
    File.prototype.getBlob = function () {
        return new File(this, "$value").get(new BlobFileParser(), { headers: { "binaryStringResponseBody": "true" } });
    };
    File.prototype.getBuffer = function () {
        return new File(this, "$value").get(new BufferFileParser(), { headers: { "binaryStringResponseBody": "true" } });
    };
    File.prototype.setContent = function (content) {
        var _this = this;
        var setter = new File(this, "$value");
        return setter.post({
            body: content,
            headers: {
                "X-HTTP-Method": "PUT",
            },
        }).then(function (_) { return new File(_this); });
    };
    File.prototype.setContentChunked = function (file, progress, chunkSize) {
        if (chunkSize === void 0) { chunkSize = 10485760; }
        if (typeof progress === "undefined") {
            progress = function (data) { return null; };
        }
        var self = this;
        var fileSize = file.size;
        var blockCount = parseInt((file.size / chunkSize).toString(), 10) + ((file.size % chunkSize === 0) ? 1 : 0);
        console.log("blockCount: " + blockCount);
        var uploadId = util_1.Util.getGUID();
        progress({ blockNumber: 1, chunkSize: chunkSize, currentPointer: 0, fileSize: fileSize, stage: "starting", totalBlocks: blockCount });
        var chain = self.startUpload(uploadId, file.slice(0, chunkSize));
        var _loop_1 = function(i) {
            chain = chain.then(function (pointer) {
                progress({ blockNumber: i, chunkSize: chunkSize, currentPointer: pointer, fileSize: fileSize, stage: "continue", totalBlocks: blockCount });
                return self.continueUpload(uploadId, pointer, file.slice(pointer, pointer + chunkSize));
            });
        };
        for (var i = 2; i < blockCount; i++) {
            _loop_1(i);
        }
        return chain.then(function (pointer) {
            progress({ blockNumber: blockCount, chunkSize: chunkSize, currentPointer: pointer, fileSize: fileSize, stage: "finishing", totalBlocks: blockCount });
            return self.finishUpload(uploadId, pointer, file.slice(pointer));
        }).then(function (_) {
            return self;
        });
    };
    File.prototype.startUpload = function (uploadId, fragment) {
        return new File(this, "startUpload(uploadId=guid'" + uploadId + "')").postAs({ body: fragment }).then(function (n) { return parseFloat(n); });
    };
    File.prototype.continueUpload = function (uploadId, fileOffset, fragment) {
        return new File(this, "continueUpload(uploadId=guid'" + uploadId + "',fileOffset=" + fileOffset + ")").postAs({ body: fragment }).then(function (n) { return parseFloat(n); });
    };
    File.prototype.finishUpload = function (uploadId, fileOffset, fragment) {
        return new File(this, "finishUpload(uploadId=guid'" + uploadId + "',fileOffset=" + fileOffset + ")")
            .postAs({ body: fragment }).then(function (response) {
            return {
                data: response,
                file: new File(response.ServerRelativeUrl),
            };
        });
    };
    return File;
}(queryable_1.QueryableInstance));
exports.File = File;
var TextFileParser = (function () {
    function TextFileParser() {
    }
    TextFileParser.prototype.parse = function (r) {
        return r.text();
    };
    return TextFileParser;
}());
exports.TextFileParser = TextFileParser;
var BlobFileParser = (function () {
    function BlobFileParser() {
    }
    BlobFileParser.prototype.parse = function (r) {
        return r.blob();
    };
    return BlobFileParser;
}());
exports.BlobFileParser = BlobFileParser;
var BufferFileParser = (function () {
    function BufferFileParser() {
    }
    BufferFileParser.prototype.parse = function (r) {
        if (util_1.Util.isFunction(r.arrayBuffer)) {
            return r.arrayBuffer();
        }
        return r.buffer();
    };
    return BufferFileParser;
}());
exports.BufferFileParser = BufferFileParser;
var Versions = (function (_super) {
    __extends(Versions, _super);
    function Versions(baseUrl, path) {
        if (path === void 0) { path = "versions"; }
        _super.call(this, baseUrl, path);
    }
    Versions.prototype.getById = function (versionId) {
        var v = new Version(this);
        v.concat("(" + versionId + ")");
        return v;
    };
    Versions.prototype.deleteAll = function () {
        return new Versions(this, "deleteAll").post();
    };
    Versions.prototype.deleteById = function (versionId) {
        return new Versions(this, "deleteById(vid=" + versionId + ")").post();
    };
    Versions.prototype.deleteByLabel = function (label) {
        return new Versions(this, "deleteByLabel(versionlabel='" + label + "')").post();
    };
    Versions.prototype.restoreByLabel = function (label) {
        return new Versions(this, "restoreByLabel(versionlabel='" + label + "')").post();
    };
    return Versions;
}(queryable_1.QueryableCollection));
exports.Versions = Versions;
var Version = (function (_super) {
    __extends(Version, _super);
    function Version(baseUrl, path) {
        _super.call(this, baseUrl, path);
    }
    Version.prototype.delete = function (eTag) {
        if (eTag === void 0) { eTag = "*"; }
        return this.post({
            headers: {
                "IF-Match": eTag,
                "X-HTTP-Method": "DELETE",
            },
        });
    };
    return Version;
}(queryable_1.QueryableInstance));
exports.Version = Version;
(function (CheckinType) {
    CheckinType[CheckinType["Minor"] = 0] = "Minor";
    CheckinType[CheckinType["Major"] = 1] = "Major";
    CheckinType[CheckinType["Overwrite"] = 2] = "Overwrite";
})(exports.CheckinType || (exports.CheckinType = {}));
var CheckinType = exports.CheckinType;
(function (WebPartsPersonalizationScope) {
    WebPartsPersonalizationScope[WebPartsPersonalizationScope["User"] = 0] = "User";
    WebPartsPersonalizationScope[WebPartsPersonalizationScope["Shared"] = 1] = "Shared";
})(exports.WebPartsPersonalizationScope || (exports.WebPartsPersonalizationScope = {}));
var WebPartsPersonalizationScope = exports.WebPartsPersonalizationScope;
(function (MoveOperations) {
    MoveOperations[MoveOperations["Overwrite"] = 1] = "Overwrite";
    MoveOperations[MoveOperations["AllowBrokenThickets"] = 8] = "AllowBrokenThickets";
})(exports.MoveOperations || (exports.MoveOperations = {}));
var MoveOperations = exports.MoveOperations;
(function (TemplateFileType) {
    TemplateFileType[TemplateFileType["StandardPage"] = 0] = "StandardPage";
    TemplateFileType[TemplateFileType["WikiPage"] = 1] = "WikiPage";
    TemplateFileType[TemplateFileType["FormPage"] = 2] = "FormPage";
})(exports.TemplateFileType || (exports.TemplateFileType = {}));
var TemplateFileType = exports.TemplateFileType;
